import provinces from "@/data/provincesOptionFormatter.json";
import industryGroups from "@/data/industryGroup.json";
import meetingOnline from "@/data/meetingOnline.json";
import workingDate from "@/data/workingDate.json";
import jobType from "@/data/jobType.json";
import faculties from "@/data/faculties.json"
import title from "@/data/title.json"
import blood from "@/data/blood.json"

var date = new Date();
var currentDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
var fifteenYearsAgo = `${date.getFullYear() - 15}-${date.getMonth() + 1}-${date.getDate()}`
var fifteenYearsAgoDateFormat = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear() - 15}`
var dateFormat = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`

let facultyList = [
  "วศ.บ. วิศวกรรมการผลิตชิ้นส่วนยานยนต์",
  "วท.บ. วิทยาศาสตร์ข้อมูลสุขภาพ",
  "วศ.บ. วิศวกรรมคอมพิวเตอร์",
  "วศ.บ. วิศวกรรมคอมพิวเตอร์ (หลักสูตรนานาชาติ)",
  "วศ.บ. วิศวกรรมเคมี ",
  "วศ.บ. วิศวกรรมเคมี (หลักสูตรนานาชาติ)",
  "วศ.บ. วิศวกรรมเครื่องกล",
  "วศ.บ. วิศวกรรมเครื่องกลและพลังงาน",
  "วศ.บ. วิศวกรรมเครื่องมือ",
  "วศ.บ. วิศวกรรมไฟฟ้า",
  "วศ.บ. วิศวกรรมไฟฟ้า (ระบบไฟฟ้า อิเล็กทรอนิกส์ และพลังงาน)",
  "วศ.บ. วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์",
  "วศ.บ. วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์ (หลักสูตรนานาชาติ)",
  "วศ.บ. วิศวกรรมเมคคาทรอนิกส์",
  "วศ.บ. วิศวกรรมยานยนต์",
  "วศ.บ. วิศวกรรมโยธา",
  "วศ.บ. วิศวกรรมโยธา (หลักสูตรนานาชาติ)",
  "วศ.บ. วิศวกรรมระบบควบคุมและเครื่องมือวัด",
  "วศ.บ. วิศวกรรมวัสดุ",
  "วศ.บ. วิศวกรรมสิ่งแวดล้อม",
  "วศ.บ. วิศวกรรมสิ่งแวดล้อม (หลักสูตรนานาชาติ)",
  "วศ.บ. วิศวกรรมอัตโนมัติ (หลักสูตรนานาชาติ) ",
  "วศ.บ. วิศวกรรมอุตสาหการ"
];

export default {
  companyInfoForm(type) {
    let schema = {
      companyInfo: [
        {
          type: "image",
          label: "รูปโปรไฟล์บริษัท",
          name: "display",
          help: "เลือกไฟล์ที่เป็น png หรือ jpg เท่านั้น",
          validation: "required|mime:image/jpeg,image/png"
        },
        {
          type: "text",
          label: "ชื่อสถานประกอบการ (ภาษาไทย)",
          name: "name-th",
          validation: "required",
          placeholder: "ชื่อสถานประกอบการ",
        },
        {
          type: "text",
          label: "ชื่อสถานประกอบการ (ภาษาอังกฤษ)",
          name: "name-en",
          validation: "required",
          placeholder: "ชื่อสถานประกอบการ",
        },
        {
          type: "radio",
          label: "กลุ่มอุตสาหกรรม",
          name: "industry_group-industry",
          validation: "required",
          options: industryGroups
        },
        {
          type: "text",
          name: "industry_group-otherIndustry",
          validation: "required",
          placeholder: "ธุรกิจอื่นๆ",
        },
      ],
      companyAddress: [
        {
          type: "text",
          label: "อาคาร/ถนน",
          name: "address-building_road",
          validation: "required",
          placeholder: "อาคาร/ถนน",
        },
        {
          type: "select",
          label: "จังหวัด",
          name: "address-province",
          options: provinces,
          validation: "required",
          placeholder: "จังหวัด",
        },
        {
          type: "select",
          label: "เขต/อำเภอ",
          name: "address-city",
          options: [],
          validation: "required",
          placeholder: "เขต/อำเภอ",
        },
        {
          type: "text",
          label: "รหัสไปรษณีย์",
          name: "address-zip_code",
          validation: "required",
          placeholder: "รหัสไปรษณีย์",
        }
      ],
      companyDetail: [
        {
          type: "url",
          label: "เว็บไซต์บริษัท",
          name: "website",
          validation: "required",
          placeholder: "เว็บไซต์บริษัท",
        },
        {
          type: "email",
          label: "E-mail (สำหรับนักศึกษาติดต่อกลับ)",
          name: "email",
          validation: "required|email",
          placeholder: "E-mail (สำหรับนักศึกษาติดต่อกลับ)",
        },
        {
          type: "editor",
          label: "ข้อมูลเกี่ยวกับบริษัท",
          name: "description",
          validation: "required",
          placeholder: "ข้อมูลเกี่ยวกับบริษัท",
        },
        {
          type: "editor",
          label: "ตำแหน่งที่รับและคุณสมบัติ",
          name: "available_job",
          validation: "required",
          placeholder: "ตำแหน่งที่รับและคุณสมบัติ",
        },
        {
          type: "checkbox",
          label: "สาขาที่รับ",
          name: "interest_faculties",
          validation: "required",
          options: facultyList
        },
        {
          type: "file",
          label: "โปสเตอร์ / โบรชัวร์",
          name: "brochure",
          help: "เลือกไฟล์ที่เป็น png หรือ jpg หรือ pdf เท่านั้น",
          validation: "required|mime:image/jpeg,image/png,application/pdf"
        },
      ]
    }

    if (type === "admin") {
      schema.sectionName = {
        companyInfo: {
          label: "ข้อมูลบริษัท",
          icon: "building"
        },
        companyAddress: {
          label: "ที่อยู่บริษัท",
          icon: "address-book"
        },
        companyDetail: {
          label: "รายละเอียดบริษัท",
          icon: "briefcase"
        },
        companyOnline: {
          label: "Online Job Fair",
          icon: "link"
        },
        companyContact: {
          label: "ข้อมูลผู้ประสานงาน",
          icon: "user-circle"
        }
      }
      schema.companyContact = [
        {
          type: "text",
          label: "ชื่อ",
          name: "contact_person-firstName",
          validation: "required",
          placeholder: "ชื่อ",
        },
        {
          type: "text",
          label: "นามสกุล",
          name: "contact_person-lastName",
          validation: "required",
          placeholder: "นามสกุล",
        },
        {
          type: "text",
          label: "ตำแหน่ง",
          name: "contact_person-position",
          validation: "required",
          placeholder: "ตำแหน่ง",
        },
        {
          type: "tel",
          label: " โทรศัพท์มือถือ (ที่สามารถติดต่อได้)",
          name: "contact_person-phone",
          validation: "required",
          placeholder: " โทรศัพท์มือถือ (ที่สามารถติดต่อได้)",
        },
        {
          type: "email",
          label: "E-mail (ที่สามารถติดต่อได้)",
          name: "contact_person-email",
          validation: "required|email",
          placeholder: "E-mail (ที่สามารถติดต่อได้)",
        },
      ]
      schema.companyOnline = [
        {
          type: "radio",
          label: "มีช่องทางสำหรับ Video Call/Online Meeting ในช่วง Job Fair",
          name: "isOnline_enable",
          validation: "required",
          options: {
            yes: "มี",
            no: "ไม่มี"
          }
        },
        {
          type: "group",
          label: "เวลา Online ช่วงเช้า วันที่ 21 มีนาคม 2565",
          name: "isOnline_dayOne_morning",
          children: [
            {
              type: "radio",
              label: "ช่วงเช้า วันที่ 21 มีนาคม 2565",
              name: "isOnline_dayOne_morning-enable",
              validation: "required",
              options: {
                yes: "มี",
                no: "ไม่มี"
              }
            },
            {
              type: "text",
              label: "link",
              name: "meeting_link",
              validation: "required",
              placeholder: "Meeting Link",
            },
            {
              type: "select",
              label: "เริ่ม",
              name: "start_time",
              options: meetingOnline.morning.start,
              validation: "required",
              placeholder: "เริ่มเวลา",
            },
            {
              type: "select",
              label: "ถึง",
              name: "end_time",
              options: meetingOnline.morning.end,
              validation: "required",
              placeholder: "ถึงเวลา",
            },
          ]
        },
        {
          type: "group",
          label: "เวลา Online ช่วงบ่าย วันที่ 21 มีนาคม 2565",
          name: "isOnline_dayOne_afternoon",
          children: [
            {
              type: "radio",
              label: "ช่วงบ่าย วันที่ 21 มีนาคม 2565",
              name: "isOnline_dayOne_afternoon-enable",
              validation: "required",
              options: {
                yes: "มี",
                no: "ไม่มี"
              }
            },
            {
              type: "text",
              label: "link",
              name: "meeting_link",
              validation: "required",
              placeholder: "Meeting Link",
            },
            {
              type: "select",
              label: "เริ่ม",
              name: "start_time",
              options: meetingOnline.afternoon.start,
              validation: "required",
              placeholder: "เริ่มเวลา",
            },
            {
              type: "select",
              label: "ถึง",
              name: "end_time",
              options: meetingOnline.afternoon.end,
              validation: "required",
              placeholder: "ถึงเวลา",
            },
          ]
        },
        {
          type: "group",
          label: "เวลา Online ช่วงเช้า วันที่ 22 มีนาคม 2565",
          name: "isOnline_dayTwo_morning",
          children: [
            {
              type: "radio",
              label: "ช่วงเช้า วันที่ 22 มีนาคม 2565",
              name: "isOnline_dayTwo_morning-enable",
              validation: "required",
              options: {
                yes: "มี",
                no: "ไม่มี"
              }
            },
            {
              type: "text",
              label: "link",
              name: "meeting_link",
              validation: "required",
              placeholder: "Meeting Link",
            },
            {
              type: "select",
              label: "เริ่ม",
              name: "start_time",
              options: meetingOnline.morning.start,
              validation: "required",
              placeholder: "เริ่มเวลา",
            },
            {
              type: "select",
              label: "ถึง",
              name: "end_time",
              options: meetingOnline.morning.end,
              validation: "required",
              placeholder: "ถึงเวลา",
            },
          ]
        },
        {
          type: "group",
          label: "เวลา Online ช่วงบ่าย วันที่ 22 มีนาคม 2565",
          name: "isOnline_dayTwo_afternoon",
          children: [
            {
              type: "radio",
              label: "ช่วงบ่าย วันที่ 22 มีนาคม 2565",
              name: "isOnline_dayTwo_afternoon-enable",
              validation: "required",
              options: {
                yes: "มี",
                no: "ไม่มี"
              }
            },
            {
              type: "text",
              label: "link",
              name: "meeting_link",
              validation: "required",
              placeholder: "Meeting Link",
            },
            {
              type: "select",
              label: "เริ่ม",
              name: "start_time",
              options: meetingOnline.afternoon.start,
              validation: "required",
              placeholder: "เริ่มเวลา",
            },
            {
              type: "select",
              label: "ถึง",
              name: "end_time",
              options: meetingOnline.afternoon.end,
              validation: "required",
              placeholder: "ถึงเวลา",
            },
          ]
        },
      ]
    } else if (type === "company") {
      schema.sectionName = {
        companyInfo: {
          label: "ข้อมูลบริษัท",
          icon: "building"
        }
      }
    } else if (type === "contact") {
      schema = {
        companyContact: [
          {
            type: "text",
            label: "ชื่อ",
            name: "contact_person-name",
            validation: "required",
            placeholder: "ชื่อ",
          },
          {
            type: "text",
            label: "นามสกุล",
            name: "contact_person-surname",
            validation: "required",
            placeholder: "นามสกุล",
          },
          {
            type: "text",
            label: "ตำแหน่ง",
            name: "contact_person-position",
            validation: "required",
            placeholder: "ตำแหน่ง",
          },
          {
            type: "tel",
            label: " โทรศัพท์มือถือ (ที่สามารถติดต่อได้)",
            name: "contact_person-phone",
            validation: "required",
            placeholder: " โทรศัพท์มือถือ (ที่สามารถติดต่อได้)",
          },
          {
            type: "email",
            label: "E-mail (ที่สามารถติดต่อได้)",
            name: "contact_person-email",
            validation: "required|email",
            placeholder: "E-mail (ที่สามารถติดต่อได้)",
          },
        ],
        sectionName: {
          companyContact: {
            label: "ข้อมูลผู้ประสานงาน",
            icon: "user-circle"
          }
        }
      }
    }

    return schema
  },
  jobAnnouncementForm(type) {
    let schema = {
      job: [
        {
          type: "text",
          label: "ตำแหน่งงานที่ต้องการรับสมัคร",
          name: "job_name",
          validation: "required",
          placeholder: "ตำแหน่งงานที่ต้องการรับสมัคร",
        },
        {
          type: "date",
          label: "วันที่ปิดรับสมัคร",
          name: "close_date",
          validation: `required|after:${currentDate}`,
          min: dateFormat,
          placeholder: "เลือกวันที่",
        },
        {
          type: "editor",
          label: "รายละเอียดงาน",
          name: "job_description",
          validation: "required",
          placeholder: "รายละเอียดงาน",
        },
        {
          type: "editor",
          label: "คุณสมบัติ",
          name: "qualification",
          validation: "required",
          placeholder: "คุณสมบัติ",
        },
        {
          type: "checkbox",
          label: "วันทำงาน",
          name: "working_days",
          validation: "required",
          options: workingDate
        },
        {
          type: "time",
          label: "เวลาเริ่มงาน",
          name: "start_time",
          validation: "required",
          placeholder: "เวลาเริ่มงาน",
        },
        {
          type: "time",
          label: "เวลาเลิกงาน",
          name: "end_time",
          validation: "required",
          placeholder: "เวลาเลิกงาน",
        },
        {
          type: "select",
          label: "ประเภทการจ้าง",
          name: "job_type",
          options: jobType,
          validation: "required",
          placeholder: "ประเภทการจ้าง",
        },
        {
          type: "text",
          label: "เงินเดือน (บาท)",
          name: "job_salary",
          placeholder: "เงินเดือน (บาท)",
        },
        {
          type: "editor",
          label: "สวัสดิการ",
          name: "benefits",
          validation: "required",
          placeholder: "สวัสดิการ",
        },
        {
          type: "checkbox",
          label: "ภาควิชาที่รับ",
          name: "interest_major",
          validation: "required",
          options: faculties
        },
      ]
    }

    if (type === "editor") {
      schema.sectionName = {
        job: {}
      }
    } else if (type === "new") {
      schema.sectionName = {
        job: {
          label: "สร้างประกาศงาน",
          icon: "plus"
        }
      }
    }
    return schema
  },
  studentForm() {
    let schema = {
      basic: [
        {
          type: "image",
          label: "รูปประจำตัว",
          name: "image_file",
          help: "เลือกไฟล์ที่เป็น png หรือ jpg เท่านั้น (อัพโหลดรูปประจำตัว เพื่อเพิ่มโอกาสในการรับเข้าสัมภาษณ์)",
          validation: "required|mime:image/jpeg,image/png"
        },
        {
          type: "select",
          label: "คำนำหน้าชื่อ",
          name: "th-title",
          options: title.th,
          validation: "required",
          placeholder: "คำนำหน้าชื่อ",
        },
        {
          type: "text",
          label: "ชื่อ (ภาษาไทย)",
          name: "th-name",
          validation: "required",
          placeholder: "ชื่อ",
        },
        {
          type: "text",
          label: "นามสกุล (ภาษาไทย)",
          name: "th-surname",
          validation: "required",
          placeholder: "นามสกุล",
        },
        {
          type: "select",
          label: "คำนำหน้าชื่อ",
          name: "en-title",
          options: title.en,
          validation: "required",
          placeholder: "คำนำหน้าชื่อ",
        },
        {
          type: "text",
          label: "ชื่อ (ภาษาอังกฤษ)",
          name: "en-name",
          validation: "required",
          placeholder: "ชื่อ",
        },
        {
          type: "text",
          label: "นามสกุล (ภาษาอังกฤษ)",
          name: "en-surname",
          validation: "required",
          placeholder: "นามสกุล",
        },
        {
          type: "select",
          label: "หลักสูตร",
          name: "curriculum",
          validation: "required",
          options: faculties,
          placeholder: "คำนำหน้าชื่อ",
        },
        {
          type: "date",
          label: "วัน/เดือน/ปี (ค.ศ.) ที่เกิด",
          name: "birth_of_date",
          validation: `required|before:${fifteenYearsAgo}`,
          max: fifteenYearsAgoDateFormat,
          placeholder: "เลือกวันที่",
        },
        {
          type: "select",
          label: "กรุ๊ปเลือด",
          name: "blood_type",
          validation: "required",
          options: blood,
          placeholder: "กรุ๊ปเลือด",
        },
      ],
      address: [
        {
          type: "text",
          label: "อาคาร/ถนน",
          name: "address-address",
          validation: "required",
          placeholder: "อาคาร/ถนน",
        },
        {
          type: "select",
          label: "จังหวัด",
          name: "address-province",
          options: provinces,
          validation: "required",
          placeholder: "จังหวัด",
        },
        {
          type: "select",
          label: "เขต/อำเภอ",
          name: "address-city",
          options: [],
          validation: "required",
          placeholder: "เขต/อำเภอ",
        },
        {
          type: "text",
          label: "รหัสไปรษณีย์",
          name: "address-zip_code",
          validation: "required",
          placeholder: "รหัสไปรษณีย์",
        },
        {
          type: "tel",
          label: " โทรศัพท์มือถือ (ที่สามารถติดต่อได้)",
          name: "phone",
          validation: "required",
          placeholder: " โทรศัพท์มือถือ (ที่สามารถติดต่อได้)",
        },
        {
          type: "email",
          label: "E-mail (ที่สามารถติดต่อได้)",
          name: "email",
          validation: "required|email",
          placeholder: "E-mail (ที่สามารถติดต่อได้)",
        },
      ],
      document: [
        {
          type: "file",
          label: "อัพโหลด CV",
          name: "resume_file",
          help: "เลือกไฟล์ที่เป็น png หรือ jpg หรือ pdf เท่านั้น",
          validation: "required|mime:image/jpeg,image/png,application/pdf"
        },
        {
          type: "textarea",
          label: "แนะนำตนเอง",
          name: "bio",
          placeholder: "เขียนอธิบายเกี่ยวกับตนเองสั้น ๆ (ไม่เกิน 240 ตัวอักษร)",
        },
        {
          type: "group",
          label: "ความสามารถทางภาษา",
          name: "language_ability",
          repeat: true,
          repeatLabel: "+ เพิ่ม",
          children: [
            {
              type: "text",
              label: "ชื่อการทดสอบ",
              name: "name",
              validation: "required",
              placeholder: "ชื่อการทดสอบ เช่น TOEIC, TOEFL ",
            },
            {
              type: "text",
              label: "คะแนน",
              name: "score",
              validation: "required",
              placeholder: "กรอกคะแนน",
            },
          ]
        }
      ]
    }

    schema.sectionName = {
      basic: {
        label: "ข้อมูลเบื้องต้น"
      },
      address: {
        label: "ข้อมูลการติดต่อ"
      },
      document: {
        label: "ข้อมูลประกอบการสมัครงาน"
      }
    }

    return schema
  }
}
